import React from "react";
var __jsx = React.createElement;
import stl from "./YearsTags.module.css";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import YearsTag from "./YearsTag/YearsTag";
import SearchArrowSVG from "./YearsTag/SVGIcons/SearchArrowSVG";
import { useLang } from "@/common/Contexts/LanguageContext";
import { generateYearsRangeList } from "@/utils/GlobalJavascriptFunction";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var YearsTags = function YearsTags(_ref) {
  var _data$tags;
  var className = _ref.className,
    selectedOptions = _ref.selectedOptions,
    metaData = _ref.metaData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useParams = useParams(),
    make = _useParams.make;
  var location = useLocation();
  var scrollRef = useRef(null);
  var parentRef = useRef(null);
  var anchor1 = useRef(null);
  var anchor2 = useRef(null);
  var scrollAmount = 600;
  var _useState = useState(false),
    Iscroll = _useState[0],
    setIscroll = _useState[1];
  var _useState2 = useState(false),
    IsLast = _useState2[0],
    setIsLast = _useState2[1];
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (scrollRef.current) {
        setTimeout(function () {
          checkWrapperShift();
        }, 310);
      }
    };
    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
    }
    return function () {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  var scroll = function scroll(dir, shift) {
    if (dir === "left" && scrollRef.current) {
      scrollRef.current.scrollLeft -= shift;
    } else if (dir === "right" && scrollRef.current) {
      scrollRef.current.scrollLeft += shift;
    }
  };
  var checkWrapperShift = function checkWrapperShift() {
    if (lang === "ar") {
      var _anchor1$current, _anchor1$current$getB, _parentRef$current, _parentRef$current$ge, _anchor2$current, _anchor2$current$getB, _parentRef$current2, _parentRef$current2$g;
      if (((_anchor1$current = anchor1.current) === null || _anchor1$current === void 0 ? void 0 : (_anchor1$current$getB = _anchor1$current.getBoundingClientRect()) === null || _anchor1$current$getB === void 0 ? void 0 : _anchor1$current$getB.left) > ((_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : (_parentRef$current$ge = _parentRef$current.getBoundingClientRect()) === null || _parentRef$current$ge === void 0 ? void 0 : _parentRef$current$ge.right)) {
        setIscroll(true);
      } else {
        setIscroll(false);
      }
      if (((_anchor2$current = anchor2.current) === null || _anchor2$current === void 0 ? void 0 : (_anchor2$current$getB = _anchor2$current.getBoundingClientRect()) === null || _anchor2$current$getB === void 0 ? void 0 : _anchor2$current$getB.left) > ((_parentRef$current2 = parentRef.current) === null || _parentRef$current2 === void 0 ? void 0 : (_parentRef$current2$g = _parentRef$current2.getBoundingClientRect()) === null || _parentRef$current2$g === void 0 ? void 0 : _parentRef$current2$g.left)) {
        setIsLast(true);
      } else {
        setIsLast(false);
      }
    } else {
      var _anchor1$current2, _anchor1$current2$get, _parentRef$current3, _parentRef$current3$g, _anchor2$current2, _anchor2$current2$get, _parentRef$current4, _parentRef$current4$g;
      if (((_anchor1$current2 = anchor1.current) === null || _anchor1$current2 === void 0 ? void 0 : (_anchor1$current2$get = _anchor1$current2.getBoundingClientRect()) === null || _anchor1$current2$get === void 0 ? void 0 : _anchor1$current2$get.right) < ((_parentRef$current3 = parentRef.current) === null || _parentRef$current3 === void 0 ? void 0 : (_parentRef$current3$g = _parentRef$current3.getBoundingClientRect()) === null || _parentRef$current3$g === void 0 ? void 0 : _parentRef$current3$g.left)) {
        setIscroll(true);
      } else {
        setIscroll(false);
      }
      if (((_anchor2$current2 = anchor2.current) === null || _anchor2$current2 === void 0 ? void 0 : (_anchor2$current2$get = _anchor2$current2.getBoundingClientRect()) === null || _anchor2$current2$get === void 0 ? void 0 : _anchor2$current2$get.right) < ((_parentRef$current4 = parentRef.current) === null || _parentRef$current4 === void 0 ? void 0 : (_parentRef$current4$g = _parentRef$current4.getBoundingClientRect()) === null || _parentRef$current4$g === void 0 ? void 0 : _parentRef$current4$g.right)) {
        setIsLast(true);
      } else {
        setIsLast(false);
      }
    }
  };
  var createData = function createData() {
    var selectedYear = selectedOptions.find(function (tag) {
      return tag.filterField === "year";
    });
    if (selectedYear) {
      var _metaData$seoData;
      var makes = metaData === null || metaData === void 0 ? void 0 : (_metaData$seoData = metaData.seoData) === null || _metaData$seoData === void 0 ? void 0 : _metaData$seoData.makes;
      return {
        tags: makes,
        title: t("select_car_make", {
          ns: "web_search"
        })
      };
    }
    return {
      tags: generateYearsRangeList(),
      title: t("select_year_manufacture", {
        ns: "web_search"
      })
    };
  };
  var data = createData();
  var createLink = function createLink(tag) {
    var selectedYear = selectedOptions.find(function (tag) {
      return tag.filterField === "year";
    });
    if (selectedYear) {
      var _tag$name_en;
      return createUrl("".concat(location.pathname.replace("/en", "").slugify(), "/").concat((_tag$name_en = tag.name_en) === null || _tag$name_en === void 0 ? void 0 : _tag$name_en.slugify()));
    }
    return createUrl("/years/".concat(tag));
  };
  if (make) return null;
  if (!(data !== null && data !== void 0 && data.tags)) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-years",
    className: "".concat(stl.wrapper, " ").concat(className || "")
  }, /*#__PURE__*/React.createElement("strong", {
    id: "posts-seo-chips-years-title",
    className: "".concat(stl.title, " m-hide")
  }, data.title), /*#__PURE__*/React.createElement("div", {
    ref: parentRef,
    id: "posts-seo-chips-years-scroll",
    className: [stl.parentWrapper, Iscroll ? stl.shiftStyle : undefined, IsLast ? stl.lastScroll : undefined].join(" ")
  }, (data === null || data === void 0 ? void 0 : data.tags.length) > 18 && /*#__PURE__*/React.createElement(SearchArrowSVG, {
    id: "posts-seo-chips-years-scroll-left",
    className: stl.leftArr,
    onClick: function onClick() {
      scroll("left", scrollAmount);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.tagsWrapper,
    ref: scrollRef
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.anchor,
    ref: anchor1
  }), data === null || data === void 0 ? void 0 : (_data$tags = data.tags) === null || _data$tags === void 0 ? void 0 : _data$tags.map(function (tag, i) {
    return /*#__PURE__*/React.createElement(YearsTag, {
      title: tag.name || tag,
      key: i,
      id: "posts-seo-chip-year-".concat(tag.id || tag),
      url: createLink(tag)
    });
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.anchor,
    ref: anchor2
  })), (data === null || data === void 0 ? void 0 : data.tags.length) > 18 && /*#__PURE__*/React.createElement(SearchArrowSVG, {
    id: "posts-seo-chips-years-scroll-right",
    className: stl.rightArr,
    onClick: function onClick() {
      scroll("right", scrollAmount);
    }
  })));
};
export default YearsTags;